import axios from 'axios'

const isAdmin = window.User !== undefined ? window.User.role.name === 'Administrator' : {}
const endpoint_expenses = isAdmin ? '/api/v2/summary/admin/expenses' : '/api/v2/summary/user/expenses'
const endpoint_invoices = isAdmin ? '/api/v2/summary/admin/invoices' : '/api/v2/summary/user/invoices'
const endpoint_cost_codes = isAdmin ? '/api/v2/summary/admin/cost-codes' : '/api/v2/summary/user/cost-codes'
const endpoint_attendances = isAdmin ? '/api/v2/summary/admin/attendances' : '/api/v2/summary/user/attendances'
const endpoint_labour = isAdmin ? '/api/v2/summary/admin/labour' : '/api/v2/summary/user/labour'

// Define summary_expenses module
export const summary_expenses = {
  state: {
    data: {}
  },
  getters: {
    getSummaryExpenses: state => {
      return state.data
    }
  },
  mutations: {
    setSummaryExpenses (state, payload) {
      state.data = payload
    }
  },
  actions: {
    async postSummaryExpenses ({ commit }, payload) {
      const response = await axios.post(endpoint_expenses, payload)
      if (response.status === 200) {
        commit('setSummaryExpenses', response.data.data)
      }
    }
  }
}

// Define summary_invoices module
export const summary_invoices = {
  state: {
    data: {}
  },
  getters: {
    getSummaryInvoices: state => {
      return state.data
    }
  },
  mutations: {
    setSummaryInvoices (state, payload) {
      state.data = payload
    }
  },
  actions: {
    async postSummaryInvoices ({ commit }, payload) {
      const response = await axios.post(endpoint_invoices, payload)
      if (response.status === 200) {
        commit('setSummaryInvoices', response.data.data)
      }
    }
  }
}

// Define summary_cost_codes module
export const summary_cost_codes = {
  state: {
    data: {}
  },
  getters: {
    getSummaryCostCodes: state => {
      return state.data
    }
  },
  mutations: {
    setSummaryCostCodes (state, payload) {
      state.data = payload
    }
  },
  actions: {
    async postSummaryCostCodes ({ commit }, payload) {
      const response = await axios.post(endpoint_cost_codes, payload)
      if (response.status === 200) {
        commit('setSummaryCostCodes', response.data.data)
      }
    }
  }
}

// Define summary_attendances module
export const summary_attendances = {
  state: {
    data: {}
  },
  getters: {
    getSummaryAttendances: state => {
      return state.data
    }
  },
  mutations: {
    setSummaryAttendances (state, payload) {
      state.data = payload
    }
  },
  actions: {
    async postSummaryAttendances ({ commit }, payload) {
      const response = await axios.post(endpoint_attendances, payload)
      if (response.status === 200) {
        commit('setSummaryAttendances', response.data.data)
      }
    }
  }
}

// Define summary_labour module
export const summary_labour = {
  state: {
    data: {}
  },
  getters: {
    getSummaryLabour: state => {
      return state.data
    }
  },
  mutations: {
    setSummaryLabour (state, payload) {
      state.data = payload
    }
  },
  actions: {
    async postSummaryLabour ({ commit }, payload) {
      const response = await axios.post(endpoint_labour, payload)
      if (response.status === 200) {
        commit('setSummaryLabour', response.data.data)
      }
    }
  }
}
